import { $logger } from '@/boot/logger'
import Typesense from 'typesense'

const host = import.meta.env.VITE_TYPESENSE_API_HOST
const port = 443
const protocol = 'https'
const FALLBACK_NODES_COUNT = 3 // Number of fallback nodes for Typesense Cloud
// Regex pattern to transform the host format for fallback nodes in Typesense Cloud.
// Matches the host format and replaces the node identifier (e.g., `-1.a1`) with a new identifier.
const TYPESENSE_HOST_TRANSFORMATION_REGEX = /^(.*?)-?[0-9]?\.a1(.*)$/

const nodes = new Array(FALLBACK_NODES_COUNT).fill(0).map((_, i) => ({
  host: host.replace(TYPESENSE_HOST_TRANSFORMATION_REGEX, `$1-${i + 1}.a1$2`),
  port,
  protocol,
}))

$logger.debug('Typesense config:', host, nodes)

export const $typesense = new Typesense.Client({
  nearestNode: {
    host,
    port,
    protocol,
  },
  nodes,
  apiKey: import.meta.env.VITE_TYPESENSE_API_KEY,
  connectionTimeoutSeconds: 5,
})
